<p-dropdown
  [placeholder]="placeholder"
  [options]="options"
  [showClear]="showClear"
  [disabled]="disabled"
  (onChange)="changeStatus($event.value?.id)"
  [optionLabel]="optionLabel"
  [(ngModel)]="selectedOption"
></p-dropdown>
